import Player from '@vimeo/player';

function cb_resetPlayers() {
    const youtube_players = document.querySelectorAll( ".yt_stream_player" );

    for (var i = 0; i < youtube_players.length; i++) {
        youtube_players[i].addEventListener( "click", function(event) {
            event.preventDefault();
            //event.stopPropagation();
            let this_player_element = this;
            this.parentElement.classList.add('playing');
            new YT.Player(this, {
                height: '360',
                width: '640',
                videoId: this.dataset.ytid,
                playerVars: {
                    'modestbranding': 1,
                },
                events: {
                    'onReady': function(event){
                        event.target.playVideo();
                        //event.target.parentElement.classList.add('playing');
                        //this_player_element.classList.add('playing');
                    },
                }
            });
        } );
    }

    const vimeo_players = document.querySelectorAll( ".vimeo_stream_player" );

    for (var i = 0; i < vimeo_players.length; i++) {
        vimeo_players[i].addEventListener( "click", function(event) {
            event.preventDefault();
            //event.stopPropagation();
            let this_player_element = this;
            let this_player = new Player(this, {
                id: this.dataset.vimeoid,
                byline: false,
                title: false,
            });

            this_player_element.querySelector('.arrow-wrap').classList.add('hide');
            //this_player_element.querySelector('.loader').classList.add('show');

            this_player.on('loaded', function(){
                //remove play button & cover image
                //this_player_element.querySelector('.loader').classList.add('hide');
                this_player_element.querySelector('.img-cover').classList.add('hide');
                this.play();
                this_player_element.classList.add('playing');
            })
        } );
    } 

}

document.addEventListener("DOMContentLoaded", function() {

    const stream_buttons = document.querySelectorAll( ".stream-button" );

    for (var i = 0; i < stream_buttons.length; i++) {
        stream_buttons[i].addEventListener( "click", function(event) {
            event.preventDefault();
            //event.stopPropagation();
            const stream_select = this.dataset.stream;
            const streams_all_wrapper = document.getElementById('streams-current__wrapper');
            const stream_1_wrapper = document.getElementById('stream_1');
            stream_1_wrapper.innerHTML = window.stream_1;
            if(typeof(window.stream_2) != 'undefined'){
                const stream_2_wrapper = document.getElementById('stream_2');
                stream_2_wrapper.innerHTML = window.stream_2;
            }            
            cb_resetPlayers();

            streams_all_wrapper.classList.remove('stream-1-active', 'stream-2-active');
            streams_all_wrapper.classList.add('stream-' + stream_select + '-active');


        });
    }


    var isStreamsPage = document.getElementsByClassName('streams-archive');
    if (isStreamsPage.length > 0) {
        isStreamsPage = true;
    } else {
        isStreamsPage = false;
    }

    if(isStreamsPage) {        
        document.addEventListener('click', function (event) {

            // If the clicked element doesn't have the right selector, bail
            if (event.target.classList.contains('arrow-right')) {
                console.log('hit');
                //open modal and set cookie
            }

        }, false);

    }

});
